module.exports = __webpack_public_path__ + "fonts/a32aa0b.ttf";